<template>
  <div class="callme_total_wrap hidden-xs-only">
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="items_wrap">
          <div class="item_tit">产品中心</div>
          <div class="item_options">
            <span @click="handleToRouter('/product/1')">产品类型</span>
            <span @click="handleToRouter('/product/2')">产品应用</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">文档中心</div>
          <div class="item_options">
            <span @click="handleToRouter('/document/1')">文档类型1</span>
            <span @click="handleToRouter('/document/2')">文档类型2</span>
            <span @click="handleToRouter('/document/3')">文档类型3</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">联系我们</div>
          <div class="item_options">
            <el-menu
              :default-active="activeIndex"
              class="el_menu_demo"
              mode="horizontal"
              background-color="#21282D"
              text-color="#8F9095"
              active-text-color="#8F9095"
              @select="handleSelect"
            >
              <el-menu-item index="1" class="el_menu_item">福安1区</el-menu-item>
              <el-menu-item index="2" class="el_menu_item">福安2区</el-menu-item>
              <el-menu-item index="3" class="el_menu_item">福安3区</el-menu-item>
            </el-menu>
            <div class="massage_show">
              <p>{{ cityInfomation[showCity].phone }}</p>
              <p>{{ cityInfomation[showCity].eamil }}</p>
              <p>{{ cityInfomation[showCity].address }}</p>
            </div>
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down" style="margin-left: 120px">
          <div class="item_tit"></div>
          <div class="item_options">
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down">
          <div class="item_tit">关注我们</div>
          <div class="item_options">
            <img src="@/assets/img/guanzhu.png" alt="" />
            <span style="text-align: center; margin-top: 15px"
              >亿微电子公众号</span
            >
          </div>
        </div>
      </div>
      <div class="navigate_wrap">
<!--        <span>友情链接:</span>
        <a href="http://www.gov.cn/">中华人民共和国中央人民政府</a>
        <a href="http://www.saism.com.cn/">软件和集成电胳</a> -->
        <p>
          Copyright ©2024 亿微电子 . All Rights Reserved . <a href="https://beian.miit.gov.cn" target="_blank">闽ICP备2025099456号-1</a>
        </p>
		<!-- 闽公网安备 33000000000000号 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      cityInfomation: [
        {
          phone: '0593-12345678',
          eamil: 'Contact@faywdz.com',
          address: '福建省福安市王基岭工业区665号6楼',
        },
        {
          phone: '0593-12345670',
          eamil: 'Contact@faywdz.com',
          address: '福建省福安市王基岭工业区665号6楼',
        },
        {
          phone: '0593-12345679',
          eamil: 'Contact@faywdz.com',
          address: '福建省福安市王基岭工业区665号6楼',
        },
      ],
      showCity: 0,
    }
  },
  methods: {
    handleSelect(index) {
      this.showCity = parseInt(index) - 1
    },
    handleToRouter(url) {
      this.$router.replace(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  margin-top: 80px;
  .callme_bottom_wrap {
    width: 100%;
    background: #21282d;
    color: #fff;
    padding-top: 70px;
    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 60px;
      border-bottom: solid #363636 2px;
      .items_wrap {
        margin-right: 100px;
        .item_tit {
          font-size: 22px;
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 120px;
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16px;
            margin-top: 35px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300PX;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15px;
            width: 300PX;
            height: 80px;
            p {
              margin-top: 30px;
            }
          }
          img {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 40px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      // display: flex;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #fff;
        padding-right: 30px;
        font-size: 18px;
        margin-right: 0;
      }
      p {
		text-align: center;
        font-size: 16px;
        color: #4e5557;
		a {
		  font-size: 16px;
		  color: #4e5557;
		}
      }
    }
  }
}
</style>